export default __webpack_public_path__ + "static/media/981.09d1c57c.jpg";